import {
  FUNCTIONS_FETCH, FUNCTIONS_FETCH_SUCCESS, FUNCTIONS_FETCH_ERROR, PROCEDURES_ADD_ALL_TO_WORKFLOW, PROCEDURE_ADD_TO_WORKFLOW,
  FUNCTIONS_SELECT_FUNCTION, FUNCTION_DETAILS_FETCH, FUNCTION_DETAILS_FETCH_ERROR, FUNCTION_DETAILS_FETCH_SUCCESS,
  PROCEDURES_SELECT_FUNCTION_AND_PROJECT, PROCEDURE_EDIT, PROCEDURE_ADD, PROCEDURE_SAVE_SUCCESS,
  FUNCTION_UPDATE_WORKFLOW_SUCCESS, PROCEDURE_ADD_TO_WORKFLOW_SUCCESS, PROCEDURES_FETCH_SUCCESS,
  PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS, PROCEDURE_ADD_TO_WORKFLOW_ERROR, PROCEDURES_ADD_ALL_TO_WORKFLOW_ERROR,
  GBUS_FETCH,
  GBUS_FETCH_SUCCESS,
  GBUS_FETCH_ERROR,
} from "../reduxActions/Types";

import _ from 'lodash';

const BLANK_PROCEDURE = {
  name: '',
  id: '',
  sdn: '',
  rev: '',
  effectiveDate: null,
  submitByDate: null,
  url: '',
  iwpp: false
};

const INITIAL_STATE = {
  addingToWorkflow: false,
  selectedFunction: null,
  selectedProject: null,
  selectedProjectFunction: null,
  fetchingProcedures: false,
  fetchingProceduresError: false,
  blankProcedure: { ...BLANK_PROCEDURE },
  procedureBeingEdited: null,
  procedures: [],
  projectSpecificProcedures: [],
  projectSpecificCorporateProcedures: [],
  fetchingGbus: false,
  gbusFetchError: false,
  gbus: null,
};


export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROCEDURES_SELECT_FUNCTION_AND_PROJECT: {


      return action.payload.selectedProject ?
        {
          ...state,
          selectedProjectFunction: action.payload.selectedFunction,
          selectedProject: action.payload.selectedProject,
          projectSpecificProcedures: [],
          projectSpecificCorporateProcedures: [],
          procedureBeingEdited: null
        }
        :
        {
          ...state,
          selectedFunction: action.payload.selectedFunction,
          procedures: [],
          procedureBeingEdited: null
        }


    }
    case PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS: {
      if (action.payload && action.payload.projectSpecificProcedures) {
        return { ...state, projectSpecificProcedures: action.payload.projectSpecificProcedures, addingToWorkflow: false }

      } else {
        return { ...state, addingToWorkflow: false }
      }

    }
    case PROCEDURE_ADD_TO_WORKFLOW:
    case PROCEDURES_ADD_ALL_TO_WORKFLOW:
      {
        return { ...state, addingToWorkflow: true }
      }

    case PROCEDURE_ADD_TO_WORKFLOW_ERROR:
    case PROCEDURES_ADD_ALL_TO_WORKFLOW_ERROR:
      {
        return { ...state, addingToWorkflow: false }
      }



    case PROCEDURE_ADD_TO_WORKFLOW_SUCCESS:
    case PROCEDURE_SAVE_SUCCESS: {

      if (state.selectedFunction && state.selectedFunction.id === action.payload.functionId || (state.selectedProjectFunction && state.selectedProjectFunction.id === action.payload.functionId && state.selectedProject.id === action.payload.projectId)) {
        const isProjectSpecific = !!action.payload.projectId;
        let procedures = isProjectSpecific ? [...state.projectSpecificProcedures] : [...state.procedures];

        const procedureIndex = procedures.findIndex(procedure => procedure.id === action.payload.id);

        if (action.payload.revisionOfId) {
          procedures = _.filter(procedures, procedure => procedure.id !== action.payload.revisionOfId);

        }

        if (procedureIndex === -1) {
          procedures.push(action.payload);

        } else {
          procedures[procedureIndex] = action.payload;
        }

        procedures = _.sortBy(procedures, ['name']);
        procedures = _.filter(procedures, procedure => procedure.delete !== true);

        return isProjectSpecific ? { ...state, projectSpecificProcedures: procedures, addingToWorkflow: false } : { ...state, procedures, addingToWorkflow: false };

      } else {
        return { ...state, addingToWorkflow: false };
      }

    }
    case PROCEDURES_FETCH_SUCCESS: {

      return action.payload.isProjectSpecific ?
        {
          ...state,
          projectSpecificProcedures: action.payload.procedures,
          projectSpecificCorporateProcedures: action.payload.projectSpecificCorporateProcedures
        }
        :
        {
          ...state,
          procedures: action.payload.procedures
        };
    }
    case PROCEDURE_ADD: {
      return {
        ...state,
        procedureBeingEdited: { ...BLANK_PROCEDURE, projectId: action.payload.projectId }
      };
    }
    case PROCEDURE_EDIT: {
      return {
        ...state,
        procedureBeingEdited: action.payload
      };
    }

    case GBUS_FETCH:
      return {
        ...state,
        fetchingGbus: true,
        gbusFetchError: false,
      };
    case GBUS_FETCH_SUCCESS:
      return {
        ...state,
        gbus: action.payload,
        fetchingGbus: false,
      };
    case GBUS_FETCH_ERROR:
      return {
        ...state,
        fetchingGbus: false,
        gbusFetchError: true,
      };

    case 'RESET_ALL_REDUX_STATE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
